import React from "react";
import { useNavigate } from "react-router-dom";

const MainCosmo = () => {
  const navigate = useNavigate();

  const buttonStyle = {
    width: "250px",
    padding: "15px",
    fontSize: "18px",
    fontWeight: "bold",
    borderRadius: "10px",
    border: "none",
    cursor: "pointer",
    margin: "10px",
  };

  return (
    <div
      style={{
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "#1e293b",
      }}
    >
      <h1
        style={{
          color: "white",
          marginBottom: "40px",
          fontSize: "36px",
        }}
      >
        Main Screen
      </h1>

      <button
        style={{
          ...buttonStyle,
          backgroundColor: "#22c55e",
          color: "white",
        }}
        onClick={() => navigate("/cosmoautomation")}
      >
        Work From Home
      </button>

      <button
        style={{
          ...buttonStyle,
          backgroundColor: "#3b82f6",
          color: "white",
        }}
        onClick={() => navigate("/FingerprintScreen")}
      >
        Shop Floor
      </button>

      <button
        style={{
          ...buttonStyle,
          backgroundColor: "#3b82f6",
          color: "white",
        }}
        onClick={() => navigate("/Hydraulics")}
      >
       Hydraulics
      </button>

        
    </div>
  );
};

export default MainCosmo;